import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import ability from '../../common/ability';
import { Action, Page } from '../../common/constants/pageAction';
import O365Licenses from './O365Licenses';
import O365UserLicenses from './O365UserLicenses';
import O365UserPlans from './O365UserPlans';
import O365UserCopilotActivitySummary from './O365UserCopilotActivitySummary';
import O365AiTimeSavings from './O365AiTimeSavings';
import O365UserAiInteractions from './O365UserAiInteractions';

const Slim360Routes: React.FC = () => {
  const match = useRouteMatch();

  return (
    <div className="slim360">
      <Switch>
        {/* o365Licenses */}
        {ability.can(Action.View, Page.Slim360O365Licenses) && (
          <Route exact path={`${match.path}/slim360-o365-licenses/:id`} component={O365Licenses} />
        )}
        {ability.can(Action.View, Page.Slim360O365Licenses) && (
          <Route exact path={`${match.path}/slim360-o365-licenses`} component={O365Licenses} />
        )}

        {/* o365UserLicenses */}
        {ability.can(Action.View, Page.Slim360O365UserLicenses) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-licenses/:id`}
            component={O365UserLicenses}
          />
        )}
        {ability.can(Action.View, Page.Slim360O365UserLicenses) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-licenses`}
            component={O365UserLicenses}
          />
        )}

        {/* o365UserPlans */}
        {ability.can(Action.View, Page.Slim360O365UserPlans) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-plans/:id`}
            component={O365UserPlans}
          />
        )}
        {ability.can(Action.View, Page.Slim360O365UserPlans) && (
          <Route exact path={`${match.path}/slim360-o365-user-plans`} component={O365UserPlans} />
        )}

        {/* o365UserCopilotActivitySummary */}
        {ability.can(Action.View, Page.Slim360O365UserCopilotActivitySummary) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-copilot-activity-summary/:id`}
            component={O365UserCopilotActivitySummary}
          />
        )}
        {ability.can(Action.View, Page.Slim360O365UserCopilotActivitySummary) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-copilot-activity-summary`}
            component={O365UserCopilotActivitySummary}
          />
        )}

        {/* o365AiTimeSavings */}
        {ability.can(Action.View, Page.Slim360O365AiTimeSavings) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-ai-time-savings/:id`}
            component={O365AiTimeSavings}
          />
        )}
        {ability.can(Action.View, Page.Slim360O365AiTimeSavings) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-ai-time-savings`}
            component={O365AiTimeSavings}
          />
        )}

        {/* o365UserAiInteractions */}
        {ability.can(Action.View, Page.Slim360O365UserAiInteractions) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-ai-interactions/:id`}
            component={O365UserAiInteractions}
          />
        )}
        {ability.can(Action.View, Page.Slim360O365UserAiInteractions) && (
          <Route
            exact
            path={`${match.path}/slim360-o365-user-ai-interactions`}
            component={O365UserAiInteractions}
          />
        )}

        {/* keep least always */}
        <Route path={`${match.path}/*`}>
          <Redirect to={`/404`} />
        </Route>
      </Switch>
    </div>
  );
};

export default Slim360Routes;
